<div class="fp-backdrop" *ngIf="isOpen" (click)="onBackdropClick()" aria-hidden="true"></div>

<aside class="fp-panel" [class.is-open]="isOpen" [attr.role]="isOpen ? 'dialog' : null" [attr.aria-modal]="isOpen ? 'true' : null" [attr.aria-hidden]="isOpen ? null : 'true'" aria-label="Filter materials">
  <header class="fp-header">
    <h2 class="fp-title">Filters</h2>
    <button type="button" class="fp-close" (click)="onClose()" aria-label="Close filters">
      <i class="material-icons" aria-hidden="true">close</i>
    </button>
  </header>

  <div class="fp-body">
    <section class="fp-section" *ngIf="materialCategories?.length">
      <h3 class="fp-section-title">Categories</h3>
      <p class="fp-section-hint">Pick one or more to combine with the chip selection.</p>
      <ul class="fp-checklist">
        <li *ngFor="let category of materialCategories">
          <label class="fp-checkbox">
            <input
              type="checkbox"
              [checked]="isCategoryChecked(category?.name)"
              (change)="toggleCategory(category?.name)"
            />
            <span>{{ category?.name }}</span>
          </label>
        </li>
      </ul>
    </section>

    <section class="fp-section" *ngIf="availableSubCategories.length">
      <h3 class="fp-section-title">Subcategory</h3>
      <ul class="fp-radiolist">
        <li>
          <label class="fp-radio">
            <input
              type="radio"
              name="fp-subcategory"
              value=""
              [checked]="draftSelectedSubCategory === ''"
              (change)="onSubCategoryChange('')"
            />
            <span>Any</span>
          </label>
        </li>
        <li *ngFor="let sub of availableSubCategories">
          <label class="fp-radio">
            <input
              type="radio"
              name="fp-subcategory"
              [value]="sub.name"
              [checked]="draftSelectedSubCategory === sub.name"
              (change)="onSubCategoryChange(sub.name)"
            />
            <span>{{ sub.name }} <em class="fp-radio-parent">({{ sub.categoryName }})</em></span>
          </label>
        </li>
      </ul>
    </section>
  </div>

  <footer class="fp-footer">
    <button type="button" class="fp-btn fp-btn-secondary" (click)="onClear()">Clear all</button>
    <button type="button" class="fp-btn fp-btn-primary" (click)="onApply()">Apply filters</button>
  </footer>
</aside>
